import { render } from "./faq.vue?vue&type=template&id=62c9bdb2&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"

import "./faq.vue?vue&type=style&index=0&id=62c9bdb2&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\feature_RPTWEB-3605_SERIALIZE-JAVASCRIPT_upgrade\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c9bdb2"]])

export default __exports__